import React, { FC } from "react";
import { ISVG } from "types/ISVG";

export const InputFileSVG: FC<ISVG> = ({width, height, className}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 25 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.9897 8.7967L7.02255 16.7639C5.81804 17.9684 5.81804 19.913 7.02255 21.103C8.22706 22.3075 10.1717 22.3075 11.3617 21.103L21.854 10.6107C24.0453 8.41938 24.0453 4.84935 21.854 2.6435C19.6627 0.452165 16.0927 0.452165 13.8868 2.6435L3.39451 13.1358C0.201831 16.3285 0.201831 21.5239 3.39451 24.7166C6.58719 27.9092 11.7825 27.9092 14.9752 24.7166L21.3461 18.3457" stroke="#00000066" strokeOpacity="0.4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
